module.exports = __webpack_public_path__ + "static/img/partnerTwo.04263db.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/partnerTwo.png
// module id = 1Wfj
// module chunks = 1